module.exports = __webpack_public_path__ + "img/group-393.eedfe3d.png";